import AccountSetupForm from './AccountSetupForm';

export default AccountSetupForm;
